namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem2Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem2';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem2Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem2Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem2Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem2Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem2/Create",
            Update = "AdvPromo/PsAdvPromoItem2/Update",
            Delete = "AdvPromo/PsAdvPromoItem2/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem2/Retrieve",
            List = "AdvPromo/PsAdvPromoItem2/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem2Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
